export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm:ss';
export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const EXPORT_DATE_FORMAT = 'YYYYMMDD';
export const DISPLAY_DATE_FORMAT = 'dd/MM/yyyy';
export const DISPLAY_DATE_TEXT_FORMAT = 'DD MMMM YYYY';
export const DISPLAY_DATE_POINT_FORMAT = 'DD.MM.YYYY';
export const DISPLAY_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';

export const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;
export const ISO_DATETIME_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z?$/;
export const TYPE_SERVICE_CACHE_DURATION = 60000;

export const SERVER_API_URL = '/api/';

export const LAST_ACTIVITY_TRIGGER_TIME = 30;
